import { FunctionComponent, useContext, useState } from 'react';
import { TextField, Typography } from '@mui/material';
import { AppContext } from '../../providers/AppContext';


interface ConnectWithMeProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const ConnectWithMe: FunctionComponent<ConnectWithMeProps> = (props: ConnectWithMeProps) => {

    const { changeData, socialMedia } = useContext(AppContext)

    const onChangeText = (id: number, text: string) => {

        const newList = socialMedia.map(item => {
            if (item.id === id) {
                item.value = text
            }
            return item
        })

        changeData({
            socialMedia: newList
        })
    }

    return (
        <div
            id={props.id}
            draggable={true}
            onDragStart={props.handleDrag}
            onDragOver={(e: any) => e.preventDefault()}
            onDrop={(e) => props.handleDrop(e, true)}
        >
            <Typography variant='h5' style={{
                marginBottom: 8,
            }}>Connect With Me</Typography>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
            }}>

                {
                    socialMedia.map(item => (
                        <div
                            key={item.id}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginRight: 32,
                            }}>
                            <td dangerouslySetInnerHTML={{ __html: item.imageUrl }} style={{
                                marginRight: 16,
                                paddingBottom: 12
                            }} />
                            <TextField
                                variant='standard'
                                size='small'
                                style={{
                                    marginBottom: 8,
                                    marginLeft: 8,
                                    width: '100%'
                                }}
                                InputProps={{
                                    disableUnderline: true
                                }}
                                placeholder={item.name + " link"}
                                onChange={(e) => onChangeText(item.id, e.target.value)}
                                value={item.value}
                            />
                        </div>
                    ))
                }

            </div>

        </div>
    );
}

export default ConnectWithMe;